import { Box, Drawer, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import CustomButton from "../ui/CustomButton";
import { closeIconButtonSx } from "../../constants/closeIconButtonSx";
import { uiNeutrals } from "../../constants/uiNeutrals";
import { appBackgroundColor } from "../../theme";
import {
  reminderHeroSubtitleSx,
  reminderHeroTitleSx,
} from "./reminderScheduleConstants";

const ReminderSetupPromptSheet = ({ open, onClose, onDismiss, onSetUp }) => {
  const handleDismiss = () => {
    onDismiss?.();
  };

  const handleSetUp = () => {
    onClose?.();
    onSetUp?.();
  };

  return (
    <Drawer
      anchor="bottom"
      open={open}
      onClose={handleDismiss}
      sx={{ zIndex: 10150 }}
      ModalProps={{ keepMounted: false }}
      PaperProps={{
        elevation: 0,
        sx: {
          width: "100%",
          maxWidth: "100%",
          borderTopLeftRadius: 20,
          borderTopRightRadius: 20,
          overflow: "hidden",
          bgcolor: appBackgroundColor,
          borderTop: uiNeutrals.frostedToggleBorder,
          boxShadow: "0 -10px 36px rgba(0, 0, 0, 0.1)",
        },
      }}
      BackdropProps={{
        sx: {
          backgroundColor: "rgba(255, 255, 255, 0.2)",
          backdropFilter: "blur(5px) saturate(1.05)",
          WebkitBackdropFilter: "blur(5px) saturate(1.05)",
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          px: 1.5,
          pt: 1,
          flexShrink: 0,
        }}
      >
        <IconButton
          onClick={handleDismiss}
          aria-label="Close reminder prompt"
          sx={closeIconButtonSx}
        >
          <CloseIcon />
        </IconButton>
      </Box>

      <Box
        sx={{
          px: 2.5,
          pt: 0,
          pb: "calc(20px + env(safe-area-inset-bottom, 0px))",
          textAlign: "center",
        }}
      >
        <NotificationsOutlinedIcon
          sx={{ fontSize: 48, color: "#0088cc", mb: 1.5 }}
        />
        <Typography sx={{ ...reminderHeroTitleSx, mb: 1 }}>
          Get deals that actually matter to you
        </Typography>
        <Typography
          sx={{
            ...reminderHeroSubtitleSx,
            maxWidth: 300,
            mx: "auto",
            mb: 2.5,
          }}
        >
          We’ll connect Telegram and send deals based on your interests
          including limited time offers.
        </Typography>

        <CustomButton
          variant="primary"
          onClick={handleSetUp}
          preventSpam={false}
          sx={{
            width: "100%",
            maxWidth: 320,
            mx: "auto",
            display: "block",
            py: 1.25,
            fontSize: "15px",
          }}
        >
          Get Telegram alerts
        </CustomButton>
        <Typography
          component="button"
          type="button"
          onClick={handleDismiss}
          sx={{
            display: "block",
            width: "100%",
            mt: 1.5,
            py: 0.75,
            border: "none",
            background: "none",
            cursor: "pointer",
            fontSize: "14px",
            fontWeight: 500,
            color: "#888",
            fontFamily: "inherit",
          }}
        >
          Not now
        </Typography>
      </Box>
    </Drawer>
  );
};

export default ReminderSetupPromptSheet;
